import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whyChoose',
  templateUrl: './whyChoose.component.html',
  styleUrls: ['./whyChoose.component.scss']
})
export class WhyChooseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
